import React from "react";
import PageHeader from "@/components/PageHeader";
import LuxuryCollections from "@/components/LuxuryCollections";
import Packages from "@/components/Packages";
import Testimonials from "@/components/Testimonials";
import CtaBanner from "@/components/CtaBanner";
import { useLayout } from "@/components/Layout";

export default function LuxuryPage() {
  const { openPlan } = useLayout();
  return (
    <div data-testid="luxury-page">
      <PageHeader
        overline="Luxury Holidays"
        title={"Bespoke journeys, styled\naround the way you live."}
        subtitle="Private villas, luxury cruises, honeymoon sanctuaries and adventure expeditions — each collection curated with concierge-grade partners across 25+ countries."
        image="https://images.pexels.com/photos/258154/pexels-photo-258154.jpeg"
      />
      <LuxuryCollections onExplore={() => {}} />
      <Packages onBook={(p) => openPlan({ destination: p.name })} />
      <Testimonials />
      <CtaBanner onPlanTrip={() => openPlan()} />
    </div>
  );
}
